module.exports = __webpack_public_path__ + "static/media/mysql.5f901844.svg";